import { render, staticRenderFns } from "./MarketplaceCart.vue?vue&type=template&id=3c9be36b&scoped=true&"
import script from "./MarketplaceCart.vue?vue&type=script&lang=js&"
export * from "./MarketplaceCart.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceCart.vue?vue&type=style&index=0&id=3c9be36b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9be36b",
  null
  
)

export default component.exports